import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import { Notification } from 'react-notification'
import useTranslation from 'next-translate/useTranslation'
import { Preloader } from 'SRC/ui/Preloader'
import { connect } from 'react-redux'
import Link from 'next/link'
import TopLoader from 'react-top-loader'
import config from 'SRC/config/config.json'
import { getIsMobileDevice } from 'SRC/modules/common/selectors'
import { Item } from '../Item'
// import { AdBreadcrumbs } from 'SRC/modules/ads/shared/components/AdBreadcrumbs'
import { getVehicleParts, getLoading, getPagination, getError } from '../../selectors'
import { fetchVehicleParts, setError } from '../../actions'

const List = ({
	parts,
	noAdsMessage,
	errorMessage,
	isLoading,
	setError
}) => {
	const { t } = useTranslation('common')

	return (
		<div className='oglasi'>
			<div className='oglasi-content oglasi-content-vehicle-parts'>
				<div
					className={`${parts.length ? 'ads-list-grid-view' : 'oglasi-content-list_no-ads'}`}
				>
					{parts.length ? parts.map(item => {
						return <Item item={item} isLoading={isLoading} key={item.id} />
					}) : isLoading
						? <Preloader />
						: (
							<div className='oglasi-content-text__no-ads-text'>
								{noAdsMessage}
							</div>
						)
					}
				</div>
			</div>

			<TopLoader show={isLoading} className='top-loader' />
			<Notification
				isActive={Boolean(errorMessage)}
				message={errorMessage || ``}
				action={t('Sakrij')}
				onClick={() => setError('')}
			/>
		</div>
	)
}

const mapStateToProps = state => {
	return {
		parts: getVehicleParts(state),
		isLoading: getLoading(state),
		pagination: getPagination(state),
		isMobileDevice: getIsMobileDevice(state),
		errorMessage: getError(state)
	}
}

List.propTypes = {
	parts: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.shape({
			name: PropTypes.string.isRequired,
			slug: PropTypes.string.isRequired
		}).isRequired,
    ean: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    discounted_price: PropTypes.string,
    discount: PropTypes.string
	})).isRequired,
	pagination: PropTypes.shape({
		currentPage: PropTypes.number.isRequired,
		countPerPage: PropTypes.number.isRequired,
		count: PropTypes.number.isRequired
	}).isRequired,
	noAdsMessage: PropTypes.string,
	isLoading: PropTypes.bool.isRequired,
	isSearchPage: PropTypes.bool,
	showBreadCrumbs: PropTypes.bool,
	isMobileDevice: PropTypes.bool.isRequired,
	errorMessage: PropTypes.string,
	setError: PropTypes.func.isRequired
}

List.defaultProps = {
	parts: [],
	isSearchPage: false,
	isLoading: false,
	showBreadCrumbs: true
}

export default connect(mapStateToProps, { setError })(List)
